import { z } from "zod";

export const AIProviderSchema = z.enum(["cloudflare", "openai", "anthropic", "mistral", "nvidia"]);
export type AIProvider = z.infer<typeof AIProviderSchema>;

export const AIModelSchema = z.string();
export type AIModel = z.infer<typeof AIModelSchema>;

export const SystemAIConfigSchema = z.object({
  providers: z.object({
    openai: z.object({
      apiKey: z.string().optional(),
      enabled: z.boolean().default(false),
    }).optional(),
    anthropic: z.object({
      apiKey: z.string().optional(),
      enabled: z.boolean().default(false),
    }).optional(),
    mistral: z.object({
      apiKey: z.string().optional(),
      enabled: z.boolean().default(false),
    }).optional(),
    nvidia: z.object({
      apiKey: z.string().optional(),
      /** Base URL — defaults to https://integrate.api.nvidia.com/v1 */
      baseUrl: z.string().url().optional(),
      enabled: z.boolean().default(false),
    }).optional(),
    cloudflare: z.object({
      accountId: z.string().optional(),
      gatewayName: z.string().optional(),
      apiToken: z.string().optional(),
      enabled: z.boolean().default(true),
    }).optional(),
  }).default({}),
  tasks: z.object({
    ocr: z.object({ provider: AIProviderSchema, model: AIModelSchema }).optional(),
    classification: z.object({ provider: AIProviderSchema, model: AIModelSchema }).optional(),
    parsing: z.object({ provider: AIProviderSchema, model: AIModelSchema }).optional(), // Praline document types
    partner_extraction: z.object({ provider: AIProviderSchema, model: AIModelSchema }).optional(),
    extraction: z.object({ provider: AIProviderSchema, model: AIModelSchema }).optional(), // Popmusik
    business_logic: z.object({ provider: AIProviderSchema, model: AIModelSchema }).optional(),
  }).default({})
});

export type SystemAIConfig = z.infer<typeof SystemAIConfigSchema>;
